import SuperText from "../SuperText";
import {MessageCodes} from "../MessageCodes";
import Constants from "../Constants";
import ResultHeader from "../../Table/ResultHeader";
import ResultRow from "../../Table/ResultRow";
import ResultBody from "../../Table/ResultBody";
import ResultBodyCell from "../../Table/ResultBodyCell";
import ResultHeaderCell from "../../Table/ResultHeaderCell";
import ResultTable from "../../Table/ResultTable";
import EmptyLine from "../../EmptyLine";
import ResultText from "../ResultText";
import CrossSectionName from "../../CrossSectionName";
import CheckCSName from "../../CheckCSName";
import {useState} from "react";
import {Radio, Switch} from "antd";

const RenderData = ({data, settings, report}) => {
    // const [skew, setSkew] = useState('not_skewed')


    return (
        <>
            <ResultText style={{marginBottom: 8}}>
                Contraction and expansion ratios at the US/DS of the structures are calculated as follows.
                Ratios that are not within {settings?.thresholds?.transition_ratio_tol * 100}% of the User Preference values ({settings?.defaults?.contraction_ratio}/{settings?.defaults?.expansion_ratio}) are highlighted in red color.
                <EmptyLine />
            </ResultText>
            {/*{*/}
            {/*    !report && (*/}
            {/*        <Radio.Group*/}
            {/*            style={{fontSize: '9pt'}}*/}
            {/*            options={[*/}
            {/*                {label: <ResultText>Not Skewed</ResultText>, value: 'not_skewed'},*/}
            {/*                {label: <ResultText>Skewed</ResultText>, value: 'skewed'},*/}
            {/*            ]}*/}
            {/*            onChange={(e) => {*/}
            {/*                setSkew(e.target.value)*/}
            {/*            }}*/}
            {/*            value={skew}*/}
            {/*            optionType="button"*/}
            {/*            buttonStyle="solid"*/}
            {/*            size={'small'}*/}
            {/*        />*/}
            {/*    )*/}
            {/*}*/}
            <EmptyLine />
            {
                data.map(r => {
                    const item = {
                        crossSection: r.cross_section,
                        type: r.type,
                        upDist: r.up_dist,
                        usName:  r.up_cross_section,
                        dsName: r.down_cross_section,
                        upLeftRatio: r.up_left_ratio,
                        upLeftRatioSkew: r.up_left_ratio_skew,
                        upLeftDist: r.up_left_diff,
                        upLeftCalc: r.up_left_calc,
                        upRightRatio: r.up_right_ratio,
                        upRightRatioSkew: r.up_right_ratio_skew,
                        upRightDist: r.up_right_diff,
                        upRightCalc: r.up_right_calc,
                        downDist: r.down_dist,
                        downLeftDist: r.down_left_diff,
                        downLeftRatio: r.down_left_ratio,
                        downLeftRatioSkew: r.down_left_ratio_skew,
                        downLeftCalc: r.down_left_calc,
                        downRightDist: r.down_right_diff,
                        downRightRatio: r.down_right_ratio,
                        downRightRatioSkew: r.down_right_ratio_skew,
                        downRightCalc: r.down_right_calc,
                        skew: r.skew
                    }
                    return (
                        <>
                            <ResultTable>
                                <ResultHeader>
                                    <ResultRow>
                                        <ResultHeaderCell style={{width: 120, textAlign: 'left'}}>
                                            {item.type || 'Type'} at <CheckCSName csName={item.crossSection || 'cross_section'} />
                                        </ResultHeaderCell>
                                        <ResultHeaderCell style={{textAlign: 'right'}}>Distance to XS</ResultHeaderCell>
                                        <ResultHeaderCell style={{textAlign: 'right'}}>Left Distance</ResultHeaderCell>
                                        <ResultHeaderCell style={{textAlign: 'right'}}>Right Distance</ResultHeaderCell>
                                        <ResultHeaderCell style={{textAlign: 'right'}}>Left Ratio</ResultHeaderCell>
                                        <ResultHeaderCell style={{textAlign: 'right'}}>Right Ratio</ResultHeaderCell>
                                        <ResultHeaderCell style={{textAlign: 'right'}}>Left R. Skewed</ResultHeaderCell>
                                        <ResultHeaderCell style={{textAlign: 'right'}}>Right R. Skewed</ResultHeaderCell>
                                    </ResultRow>
                                </ResultHeader>
                                <ResultRow>
                                    <ResultHeaderCell style={{width: 120, textAlign: 'start'}}>US ({item.usName})</ResultHeaderCell>
                                    <ResultBodyCell style={{textAlign: 'right'}}>{item.upDist || 'None'}</ResultBodyCell>
                                    <ResultBodyCell style={{textAlign: 'right'}}>{item.upLeftDist || 'None'}</ResultBodyCell>
                                    <ResultBodyCell style={{textAlign: 'right'}}>{item.upRightDist || 'None'}</ResultBodyCell>
                                    <ResultBodyCell style={{textAlign: 'right'}}>
                                        <SuperText text={item.upLeftCalc} />
                                        {isLimit(settings, item.upLeftRatio || 'None', 'cont')}
                                    </ResultBodyCell>
                                    <ResultBodyCell style={{textAlign: 'right'}}>
                                        <SuperText text={item.upRightCalc} />
                                        {isLimit(settings, item.upRightRatio || 'None', 'cont')}
                                    </ResultBodyCell>
                                    <ResultBodyCell style={{textAlign: 'right'}}>
                                        <SuperText text={item.upLeftCalc} />
                                        {isLimit(settings, item.upLeftRatioSkew || 'None', 'cont')}
                                    </ResultBodyCell>
                                    <ResultBodyCell style={{textAlign: 'right'}}>
                                        <SuperText text={item.upRightCalc} />
                                        {isLimit(settings, item.upRightRatioSkew || 'None', 'cont')}
                                    </ResultBodyCell>
                                </ResultRow>
                                <ResultRow>
                                    <ResultHeaderCell style={{width: 120, textAlign: 'start'}}>DS ({item.dsName})</ResultHeaderCell>
                                    <ResultBodyCell style={{textAlign: 'right'}}>{item.downDist || 'None'}</ResultBodyCell>
                                    <ResultBodyCell style={{textAlign: 'right'}}>{item.downLeftDist || 'None'}</ResultBodyCell>
                                    <ResultBodyCell style={{textAlign: 'right'}}>{item.downRightDist || 'None'}</ResultBodyCell>
                                    <ResultBodyCell style={{textAlign: 'right'}}>
                                        <SuperText text={item.downLeftCalc} />
                                        {isLimit(settings, item.downLeftRatio || 'None', 'exp')}
                                    </ResultBodyCell>
                                    <ResultBodyCell style={{textAlign: 'right'}}>
                                        <SuperText text={item.downRightCalc} />
                                        {isLimit(settings, item.downRightRatio || 'None', 'exp')}
                                    </ResultBodyCell>
                                    <ResultBodyCell style={{textAlign: 'right'}}>
                                        <SuperText text={item.downLeftCalc} />
                                        {isLimit(settings, item.downLeftRatioSkew || 'None', 'exp')}
                                    </ResultBodyCell>
                                    <ResultBodyCell style={{textAlign: 'right'}}>
                                        <SuperText text={item.downRightCalc} />
                                        {isLimit(settings, item.downRightRatioSkew || 'None', 'exp')}
                                    </ResultBodyCell>
                                </ResultRow>
                            </ResultTable>
                            Skew Angle: {item.skew}
                            <EmptyLine/>
                        </>
                    )
                })
            }
            <div>
                <div><SuperText text={'1'} /> Low chord data is used to identify the bridge opening station.</div>
                <div><SuperText text={'2'} /> Abutment data is used to identify the bridge opening station.</div>
                <div><SuperText text={'3'} /> Low chord or Abutment data does not define bridge opening station.</div>
                <div><SuperText text={'4'} /> Ineffective area station is missing.</div>
                <div><SuperText text={'5'} /> Contraction/Expansion ratio could not be calculated since the ineffective station is at the structure opening.</div>
            </div>
        </>
    )
}

const isLimit = (settings, val, type) => {
    if(val === 'None' || !val)
        return (
            <text style={{color: 'red'}}>
                {val}
            </text>
        )

    if(type === 'exp') {
        const def = settings?.defaults?.expansion_ratio;
        const ratio = settings?.thresholds?.transition_ratio_tol;
        const tolerance = def*ratio;
        if(val >= def - tolerance && val <= def + tolerance) {
            return val
        }
    }
    else if(type === 'cont') {
        const def = settings?.defaults?.contraction_ratio;
        const ratio = settings?.thresholds?.transition_ratio_tol;
        const tolerance = def*ratio;
        if(val >= def - tolerance && val <= def + tolerance)
            return val
    }

    return (
        <text style={{color: 'red'}}>
            {val}
        </text>
    )
}

const RenderDescription = ({text, row, settings, globalVariables, report}) => {
    if(row.error_id === MessageCodes.Internal.CES001.error_id) {
        const data = row.data;
        if(data) {
            return (
                <>
                    <RenderData data={data} settings={settings} report={report} />
                </>
            )
        }
    }
}


export const B5 = {
    RenderDescription
}